export default __webpack_public_path__ + "static/media/style.e3f934bf.less";